import React from 'react';
import './Header.css'; // Import the CSS file for the header
import logo from './logo.jpeg'; // Import the logo image

const Header = () => {
    return (
        <div className="header">
            <img src={logo} alt="Company Logo" className="logo-img" />
        </div>
    );
};

export default Header;